/**
 * HOME-TEMPLATES-SKELETON.WIDGET
 * Skeleton adapté à home-templates.widget.tsx : libellé, nom du dernier questionnaire, illustration ronde
 * et lien, centrés comme la carte réelle.
 */
import Skeleton from "@/components/skeleton"

export default function HomeTemplatesSkeletonWidget() {
  return (
    <div className="flex flex-dcol" style={{ alignItems: "center", gap: 12, minHeight: 200 }}>
      <Skeleton width={150} height={12} />
      <Skeleton width={200} height={18} />
      <Skeleton width={80} height={80} isCircle style={{ margin: "16px 0" }} />
      <Skeleton width={110} height={14} />
    </div>
  )
}
